/*************************************************************************
 * お知らせ Store State / Getters
 * @namespace notice
 *************************************************************************/
import actions from './actions.js';
import mutations from './mutations.js';

/*************************************************************************
 * state
 *************************************************************************/
const state = () => ({
  errors: [],
  allList: [],
  newsList: [],
  newsTimelines: [],
  news: {},
  timelines: [],
  hasClinic: null,
  isPartner: null,
  clinics: [],
  timeline: {},
  pagination: {
    total_pages: 0,
    current_page: 0,
    timelines_count: null,
    news_timelines_count: null,
  },
});

/*************************************************************************
 * getters
 *************************************************************************/
const getters = {
  pagination: (state) => state.pagination,
  totalPages: (state) => state.pagination.total_pages,
  currentPage: (state) => state.pagination.current_page,

  allList: (getters) => {
    let allList = [];
    const newsList = getters.newsList;
    const timelines = getters.timelines;

    allList = Object.assign(newsList, timelines);
    return allList.sort((x, y) => {
      return new Date(y.deliver_date) - new Date(x.deliver_date);
    });
  },

  news: (state) => state.news,
  newsList: (state) => state.newsList,
  newsTimelines: (state) => state.newsTimelines,
  newsTimelinesCount: (state) => state.pagination.news_timelines_count,
  timelinesCount: (state) => state.pagination.timelines_count,

  timeline: (state) => state.timeline,
  hasClinic: (state) => state.hasClinic,
  isPartner: (state) => state.isPartner,
  timelines: (state) => state.timelines,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
